<template>
  <div class="error-header-section">
    <h3 class="error-header-section__title">{{ title }}</h3>
  </div>
</template>
<script lang="ts">
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'ErrorHeaderSection',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
</script>
<style scoped lang="scss">
.error-header-section {
  background: $white;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 5%);

  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    @include fontSetTextMedium();

    font-weight: 700;
  }
}
</style>
